import { Employee } from './employee.model';

export interface EmployeeState {
    list: Employee[];
}

export const initialEmployeeState: EmployeeState = {
    list: new Array()
};